exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WishLists-wishListPadding-1H-R0 {\n    padding: 42px 0px 42px 0px;\n}", ""]);

// exports
exports.locals = {
	"wishListPadding": "WishLists-wishListPadding-1H-R0"
};